// extracted by mini-css-extract-plugin
export default {"wrapper":"Rewards_wrapper__dFQbB","sidebarWrapper":"Rewards_sidebarWrapper__sD-ml","sectionWrapper":"Rewards_sectionWrapper__NeZ8-"};